/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * This function transforms all the numbers inside a object into string
 * If it's an array, it recursively calls itself for each element in the array.
 * If it's an object, it iterates over its properties and recursively calls itself for each property. If it's a number, it converts it to a string.
 *
 * @param obj Array, object, or a number
 * @returns New object/array with the same structure but with numbers transformed into strings.
 */
export const parseObjectToStrings = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map((item) => parseObjectToStrings(item));
  } else if (typeof obj === 'object' && obj !== null) {
    const newObj: any = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        newObj[key] = parseObjectToStrings(obj[key]);
      }
    }
    return newObj;
  } else if (typeof obj === 'number') {
    return obj.toString();
  }
  return obj;
};
